import { render } from "./PizZaboxes.vue?vue&type=template&id=46dd7208"
const script = {}

import exportComponent from "../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/PizZaboxes.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "46dd7208"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('46dd7208', __exports__)) {
    api.reload('46dd7208', __exports__)
  }
  
  module.hot.accept("./PizZaboxes.vue?vue&type=template&id=46dd7208", () => {
    api.rerender('46dd7208', render)
  })

}


export default __exports__